import { Component } from '@angular/core';

@Component({
  selector: 'app-survey-backlog',
  templateUrl: './survey-backlog.component.html',
  styleUrl: './survey-backlog.component.css',
})
export class SurveyBacklogComponent {}
